











import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
  name: "ItemsList"
})
export default class ItemsList extends Vue {
  @Prop({default: ""}) title: string;
  @Prop({required: true}) list: any[];
  @Prop({default: ''}) keyField: string;
}
